import Vue from 'vue'
import Vuex from 'vuex'
import utilidadesStore from './modules/utilidades.store'
import personaDocumentosStore from './modules/personaDocumentos.store'
import creditoStore from './modules/credito.store'
import personaStore from './modules/persona.store'
import guiaStore from './modules/guia.store'
import sesionStore from './modules/sesion.store'
import alertaStore from './modules/alerta.store'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    layout: 'Layout',
  },
  mutations: {
    ESTABLECER_LAYOUT(state, nuevoLayout) {
      state.layout = nuevoLayout
    },
    inicializarStore(state) {
      if (localStorage.getItem('store')) {
        this.replaceState(
          Object.assign(state, JSON.parse(localStorage.getItem('store')))
        )
      }
    },
    reiniciarStore() {
      localStorage.removeItem('store')
    },
  },
  modules: {
    personaDocumentos: personaDocumentosStore,
    utilidades: utilidadesStore,
    credito: creditoStore,
    persona: personaStore,
    guia: guiaStore,
    sesion: sesionStore,
    alerta: alertaStore,
  },
})

// store.subscribe((_, state) => {
//   if (state.credito.folioDigital !== '') {
//     localStorage.setItem('store', JSON.stringify(state))
//   }
// })

export default store
